import React from 'react'
import PropTypes from 'prop-types'
import { ChallengePostTemplate } from '../../templates/challenge-post'
import { wrapRootElement } from '../../apollo/wrapRootElement'

const ChallengePostPreview = ({ entry, widgetFor }) => {
  const data = entry.getIn(['data']).toJS()

  const preview = (
    <ChallengePostTemplate
      challenge={data}
      metadata={ {
        joinChallengeUrl: "http://www.example/com",
      }}
    />
  )

  return wrapRootElement({ element: preview })
}

ChallengePostPreview.propTypes = {
  entry: PropTypes.shape({
    getIn: PropTypes.func,
  }),
  widgetFor: PropTypes.func,
}

export default ChallengePostPreview
